// src/screens/formateur/FormateurOrderListScreen.js - AVEC DEBUG
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Badge, Card } from 'react-bootstrap';
import { FaTimes, FaCheck, FaEye, FaBox } from 'react-icons/fa';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetFormateurOrdersQuery } from '../../slices/ordersApiSlice';

const FormateurOrderListScreen = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  
  const { 
    data: orders, 
    isLoading, 
    error 
  } = useGetFormateurOrdersQuery();

  // 🔍 DEBUG IMPORTANT
  useEffect(() => {
    // console.log('🔐 DEBUG Formateur User Info:', {
    //   userInfo: userInfo,
    //   userId: userInfo?._id,
    //   isFormateur: userInfo?.isFormateur,
    //   name: userInfo?.name,
    //   email: userInfo?.email
    // });
  }, [userInfo]);

  useEffect(() => {
    if (!userInfo || !userInfo.isFormateur) {
      // console.log('🚫 Accès refusé - Pas formateur ou non connecté');
      navigate('/login');
    }
  }, [userInfo, navigate]);

  // 🔍 DEBUG des données reçues
  useEffect(() => {
    if (orders) {
      // console.log('📦 DEBUG Formateur Orders Received:', {
      //   ordersCount: orders.length,
      //   orders: orders
      // });
    }
  }, [orders]);

  if (isLoading) {
    // console.log('🔄 Chargement des commandes formateur...');
    return <Loader />;
  }

  if (error) {
    console.error('❌ Erreur chargement commandes formateur:', error);
    return <Message variant='danger'>{error?.data?.message || error.error}</Message>;
  }

  // console.log('🎯 Rendu du tableau avec orders:', orders);

  const totalSales = orders?.reduce((total, order) => {
    const orderTotal = order.orderItems.reduce((orderSum, item) => {
      return orderSum + (item.price * item.qty);
    }, 0);
    return total + orderTotal;
  }, 0) || 0;

  return (
    <div className="container mt-4">
      <div className="row mb-4">
        <div className="col-md-8">
          <h1>Commandes de mes produits</h1>
          <p className="text-muted">Vous voyez seulement les commandes contenant vos produits</p>
          {/* 🔍 DEBUG AFFICHAGE */}
          <div className="alert alert-info">
            <small>
              <strong>DEBUG:</strong> Formateur ID: {userInfo?._id} | 
              Commandes trouvées: {orders?.length || 0}
            </small>
          </div>
        </div>
        <div className="col-md-4">
          <Card className="bg-primary text-white">
            <Card.Body className="text-center">
              <FaBox size={24} className="mb-2" />
              <h4>{orders?.length || 0} Commandes</h4>
              <h5>{totalSales.toFixed(2)} TND</h5>
              <small>Total des ventes</small>
            </Card.Body>
          </Card>
        </div>
      </div>

      {orders && orders.length > 0 ? (
        <Table striped bordered hover responsive className='table-sm'>
          <thead className="table-dark">
            <tr>
              <th>Client</th>
              <th>Date</th>
              <th>Produits (Vos)</th>
              <th>Total Commande</th>
              <th>Vos Produits</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => {
              const formateurItemsTotal = order.orderItems.reduce((sum, item) => sum + (item.price * item.qty), 0);
              const formateurItemsCount = order.orderItems.length;

              return (
                <tr key={order._id}>
                  <td>
                    {order.user ? (
                      <div>
                        <div><strong>{order.user.name}</strong></div>
                        <small className="text-muted">{order.user.email}</small>
                      </div>
                    ) : (
                      <span className="text-danger">Client inconnu</span>
                    )}
                  </td>
                  <td>{new Date(order.createdAt).toLocaleDateString('fr-FR')}</td>
                  <td>
                    <div>
                      {order.orderItems.map((item, index) => (
                        <div key={index} className="mb-1">
                          <Badge bg="light" text="dark" className="me-1">
                            {item.qty}x
                          </Badge>
                          {item.name}
                          <br />
                          <small className="text-muted">
                            {item.price} TND × {item.qty} = {(item.price * item.qty).toFixed(2)} TND
                          </small>
                        </div>
                      ))}
                    </div>
                  </td>
                  <td>
                    <Badge bg="secondary" className="fs-6">
                      {order.totalPrice} TND
                    </Badge>
                  </td>
                  <td>
                    <Badge bg="success" className="fs-6">
                      {formateurItemsTotal.toFixed(2)} TND
                    </Badge>
                    <br />
                    <small className="text-muted">{formateurItemsCount} produit(s)</small>
                  </td>
                  <td>
                    {order.isPaid ? (
                      <Badge bg="success" className="d-flex align-items-center gap-1">
                        <FaCheck /> Payé
                      </Badge>
                    ) : (
                      <Badge bg="warning" className="d-flex align-items-center gap-1">
                        <FaTimes /> En attente
                      </Badge>
                    )}
                  </td>
                  <td>
                    <Link to={`/order${order.paymentMethod}/${order._id}`}>
                      <Button className='btn-sm' variant='outline-primary'>
                        <FaEye className="me-1" />
                        Détails
                      </Button>
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      ) : (
        <Message variant="info">
          <FaBox className="me-2" />
          Aucune commande trouvée pour vos produits.
          <br />
          <small className="text-muted">
            Vérifiez que vous avez des produits créés et qu'ils ont été achetés.
          </small>
        </Message>
      )}
    </div>
  );
};

export default FormateurOrderListScreen;